
export function loadingReducer (state, action) {
    switch(action.type) {
      case 'start': return state = true;
      case 'stop': return state = false;
      default: return state;
    }  
  }